module.exports = [{
      plugin: require('/Users/Can/Projekte/Michael Curth/rescue-amazonian-rainforest.com/www/node_modules/gatsby-plugin-emotion/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/Can/Projekte/Michael Curth/rescue-amazonian-rainforest.com/www/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    }]
